<template>
	<b-container fluid class="no-padding">
		<b-row class="my-1 stencilform">

			<b-col lg="7" sm="12" class="stencilform-previews no-padding" id="stencilform-previews" :class="stencilPreviewScroll">
				<preview-form></preview-form>
			</b-col>

			<b-col lg="5" class="stencilform-tools no-padding">
                <div role="tablist" class="stencilform-mobile">
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion1 variant="info"><i class="fa fa-edit"></i><span>add text</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                            <step-text></step-text>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion2 variant="info"><i class="fa fa-font"></i><span>select font</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                            <step-font></step-font>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion3 variant="info"><i class="fa fa-text-height"></i><span>letter height</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
                            <step-height></step-height>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion4 variant="info"><i class="fa fa-align-left"></i><span>alignment</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel">
                            <step-alignment></step-alignment>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion5 variant="info"><i class="fa fa-building"></i><span>material</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion5" accordion="my-accordion" role="tabpanel">
                            <step-material></step-material>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion6 variant="info"><i class="fa fa-check"></i><span>approval</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion6" accordion="my-accordion" role="tabpanel">
                            <step-approval></step-approval>
                        </b-collapse>
                    </b-card>
                    <b-card no-body>
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" v-b-toggle.accordion7 variant="info"><i class="fa fa-plus"></i><span>quantity</span></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion7" accordion="my-accordion" role="tabpanel">
                            <step-quantity></step-quantity>
                        </b-collapse>
                    </b-card>
                </div>
			</b-col>

		</b-row>
	</b-container>

</template>

<script>
import jQuery from 'jquery'

import previewForm from './stencilease-form-preview.vue'
import stepText from './stencilease-form-step-text.vue'
import stepFont from './stencilease-form-step-font.vue'
import stepHeight from './stencilease-form-step-height.vue'
import stepAlignment from './stencilease-form-step-alignment.vue'
import stepMaterial from './stencilease-form-step-material.vue'
import stepApproval from './stencilease-form-step-approval.vue'
import stepQuantity from './stencilease-form-step-quantity.vue'

export default {
	components: {
		jQuery,
		previewForm,
		stepText,
		stepFont,
		stepHeight,
		stepAlignment,
		stepMaterial,
        stepApproval,
		stepQuantity
	},
    computed: {
        stencilPreviewScroll() {
            jQuery(window).scroll(function() {
                // declare variable
                var topPos = jQuery(this).scrollTop();

                // if user scrolls down - show scroll to top button
                if (topPos > 50) {
                    jQuery('#stencilform-previews').css("top", "0");
                } else {
                    jQuery('#stencilform-previews').css("top", "unset");
                }
            }); // scroll END

            return true;
        }
    }
}
</script>